import { IconStyles } from '../types'
import { LockIconCustom } from './styles'

interface LockIconProps extends IconStyles {
  onClick?: () => void
}

export const LockIcon = ({
  onClick,
  cursor,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  disabled,
  colorIcon
}: LockIconProps) => {
  return (
    <LockIconCustom
      disabled={disabled}
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      cursor={cursor}
      onClick={onClick}
      colorIcon={colorIcon}
    />
  )
}
